import * as Yup from "yup";

export const FormRestaurantScheme = () => {
    return Yup.object().shape({
        name: Yup.string()
            .required("El nombre del restaurante es obligatorio")
            .trim(),
        categoriaPrincipal: Yup.string()
            .required("Debes seleccionar una categoría principal"),
        categorias: Yup.array()
            .of(Yup.string().trim())
            .min(1, "Debes seleccionar al menos una subcategoría"),
        direccion: Yup.string()
            .required("La dirección es obligatoria")
            .trim(),
        lat: Yup.number()
            .typeError("Latitud inválida")
            .required("La latitud es obligatoria"),
        lng: Yup.number()
            .typeError("Longitud inválida")
            .required("La longitud es obligatoria"),
        tiempoEntregaEstimado: Yup.number()
            .min(10, "El tiempo mínimo es 10 minutos")
            .max(120, "El tiempo máximo es 120 minutos")
            .required("El tiempo estimado es obligatorio"),
        costoEnvio: Yup.number()
            .min(30, "El costo de envío no puede ser negativo")
            .required("El costo de envío es obligatorio"),
        phone: Yup.string()
            .matches(/^[0-9]{10}$/, "El teléfono debe tener 10 dígitos")
            .required("El teléfono es obligatorio"),
        email: Yup.string()
            .email("Correo inválido")
            .required("El correo es obligatorio"),
        isActive: Yup.boolean().default(false),
    });
};
